import React from 'react';
import styled from 'styled-components';

import { Futura } from '~/styles';
import { media } from '~/utils';

export default function ({ org, large = false, onClick }) {
  return (
    <Wrapper large={large}>
      <Title>解決しようとしている社会課題</Title>
      <Tags large={large}>
        {org.tags.map((tag, i) => (
          <Tag key={i} large={large}>
            #{tag.name}
          </Tag>
        ))}
      </Tags>
      {large && <TagText>{org.tagText}</TagText>}
      {!large && <SeeMore onClick={onClick}>SEE MORE</SeeMore>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid #707070;
  position: relative;

  ${media.mid`
    margin: 0 10px;
  `}
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #3c3c3c;
`;

const Tags = styled.div`
  margin-top: 5px;
  margin-left: 35px;
  padding-right: 35px;
  padding-bottom: 60px;
  overflow: hidden;

  ${(props) =>
    props.large &&
    `
    margin-left: 25px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: auto;
  `}
`;

const Tag = styled.div`
  margin-top: 8px;
  font-size: 16px;
  font-weight: bold;
  color: #3c3c3c;

  ${(props) =>
    props.large &&
    `
    margin-left: 10px;
  `}
`;

const TagText = styled.div`
  padding-top: 20px;
  margin: 20px 35px 40px;
  border-top: 1px solid #707070;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 1px;
  color: #262626;
`;

const SeeMore = styled(Futura)`
  position: absolute;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
  left: 35px;
  bottom: 10px;
`;
